window.addEventListener('DOMContentLoaded', () => {
  const resizableSwiper = (breakpoint, swiperClass, swiperSettings, callback) => {
    const slider = document.querySelector(swiperClass);
    if (!slider) return;

    let swiper;
    breakpoint = window.matchMedia(breakpoint);

    const enableSwiper = (className, settings) => {
      swiper = new Swiper(className, settings);
      if (callback) callback(swiper);
    };

    const checker = () => {
      if (breakpoint.matches) {
        enableSwiper(swiperClass, swiperSettings);
      } else {
        if (swiper) swiper.destroy(true, true);
      }
    };

    breakpoint.addEventListener('change', checker);
    checker();
  };

  const someFunc = (instance) => {
    instance?.on('slideChange', () => {
      console.log('*** mySwiper.activeIndex', instance.activeIndex);
    });
  };

  resizableSwiper(
    '(max-width: 1000px)',
    '.calendar__slider',
    {
      spaceBetween: 10,
      slidesPerView: 2,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      speed: 1000,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        600: {
          slidesPerView: 2,
        }
      }
    },
    someFunc
  );
});
